// Added AP 05-10-23 Essential Countdown Timer bar(AP Updated GA script on 09-10-2023)
let essential_countdownBarEnable = setInterval(function(){
  const essential_countdown_bar_wrapper = document.getElementsByClassName("essential_countdown_annoucement_bar_wrapper").length;
    if(essential_countdown_bar_wrapper > 0){
      const essential_countdown_bar = document.querySelector(".essential_countdown_annoucement_bar_wrapper").clientHeight
      
        document.querySelector("body").classList.add("essential_countdown-bar-enable");
        document.querySelector(".section-header").setAttribute("style","top:"+essential_countdown_bar+"px");
          if(document.querySelector(".essential_countdown_annoucement_bar_wrapper") != undefined){        
                document.querySelector(".essential_countdown_annoucement_bar_wrapper").addEventListener('click', (event) => {
                  var nodeName = event.target.nodeName;
                      nodeName = nodeName.toLowerCase();
                    if(nodeName == 'path' || nodeName == 'svg' || nodeName == 'button'){
                        if(typeof gtag != "undefined")
                         gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar close','value': 'promo bar closed'});              
                    }
                    else{
                      if(typeof gtag != "undefined")		
                       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar click','value': 'click promo bar'});
                    }
              });        
          }      
        clearInterval(essential_countdownBarEnable);
    }

  if(document.querySelector(".essential_countdown_annoucement_bar_wrapper button") != undefined){
    document.querySelector(".essential_countdown_annoucement_bar_wrapper button").addEventListener('click', (event) => {       
      document.querySelector("body").classList.remove("essential_countdown-bar-enable");      
      document.querySelector(".section-header").removeAttribute("style");
    });
  }  
}, 1000);

/* wishlist script for wishlistpop AP added */



$('.wishlist_product_button').on('click touchstart ', function(e){

   //alert("click call");
   var product_Id =$(this).data('product-id');
   //e.preventDefault();
   $.fancybox.open({
   	 src  : '#login_form',
     type : 'inline',
     afterShow: function( instance, current ) {
     current_url = window.location.pathname;
       
       /*hd added 01/10/2020*/
       if(current_url.indexOf('?') > -1){
         current_url += '&wk-intent={"action":"addProduct","product":"'+product_Id+'","variant":"'+$('.multi_select').val()+'"}';
         history.pushState("", "", current_url+"");
       }else{
         current_url += '?wk-intent={"action":"addProduct","product":"'+product_Id+'","variant":"'+$('.multi_select').val()+'"}';
       }
       /*hd added 01/10/2020*/
       
     	$('input[name="checkout_url"]').val(current_url);

     }
   });
});

/* This process is for product swath changes added by HD */


/*======= PDP elements update AP added start =========== */
/* purpose: for PDP elements description and review A/B testing  */
//createCookie("PDP_description_elements","");

function PDP_desktop_elements_function(element){
  
  createCookie("PDP_expand_element",element);  

  setTimeout(function(){      
    if(readCookie('PDP_expand_element') == "description"){
      $("summary.description").parent().addClass("is-open").attr("open", "");
    }
    else if(readCookie('PDP_expand_element') == "reviews"){
      $("summary.reviews").parent().addClass("is-open").attr("open", "");
    }
  },1000);
}

function PDP_mobile_elements_function(mobile_element){    
  createCookie("PDP_mobile_expand_element",mobile_element);  
    if(window.matchMedia('(max-width: 767.99px)').matches){
        setTimeout(function(){
          if(readCookie('PDP_mobile_expand_element') == "description"){
            $("summary.description").parent().addClass("is-open").attr("open", "");
          }
          else if(readCookie('PDP_mobile_expand_element') == "reviews"){
            $("summary.reviews").parent().addClass("is-open").attr("open", "");
          }
        },1000);
    }
}

/*======= AP added announcementBar script start =========== */
function customAnnouncementBarEnable(e){
 
let customAnnouncementBarEnable = setInterval(function(){
  const custom_announcement_bar_wrapper = document.getElementsByClassName("section-announcement-bar").length;
    if(custom_announcement_bar_wrapper > 0){
      const custom_announcement_bar = document.querySelector(".section-announcement-bar").clientHeight      
        
      document.querySelector("body").classList.add("custom_announcement_bar-enable");
      document.querySelector(".section-header").setAttribute("style","top:"+custom_announcement_bar+"px");                
      console.log("custom_announcement_bar",custom_announcement_bar);
      document.querySelector("#content").setAttribute("style","top:"+custom_announcement_bar+"px; margin-bottom:"+custom_announcement_bar+"px;");
      
      clearInterval(customAnnouncementBarEnable);
    }  
}, 1500);
}
customAnnouncementBarEnable();
document.addEventListener("DOMContentLoaded", function(){
  customAnnouncementBarEnable();
});

window.addEventListener("resize", function(){
  customAnnouncementBarEnable();
});

/*======= AP added announcementBar script end =========== */

/*======= afterpay msg show only US added by HB 13-Apr-2023 =========== */
// function afterpayMsgHide(){
//     var checkLocalAftrpay = readCookie('localizationtemp');  
//     if($.inArray(checkLocalAftrpay, ['US','us']) == -1){
//       $(".slide_cart_inner .checkout_block_container .cart-policies").css("margin-bottom", "10px");
//       return false;      
//        // $(".price-container").find(".afterpay-paragraph").addClass("hidden");    
//     }else{
//       $(".slide_cart_inner .checkout_block_container .cart-policies").css("margin-bottom", "0px");
//       return true;
//     }
// }

/*======= PDP elements update AP added end =========== */

/*======= Hide Multi Badge on Collections update AP added start 26-12-2023 =========== */

function multi_tag_hide_function(){  
 setTimeout(function(){
   if(readCookie('hide_multi_tag') == "true"){
     $(".collection_multi_tags").removeClass("hidden");
     $(".collection_multi_tags span").addClass("hidden");     
     $(".collection_multi_tags").children(".custom_badges:nth-child(1)").removeClass("hidden");
    }
   else{
      $(".collection_multi_tags").removeClass("hidden");
      $(".collection_multi_tags span").removeClass("hidden");
   }
  },1000);
}
  multi_tag_hide_function();
/*======= Hide Multi Badge on Collections update AP added end 26-12-2023 =========== */

/*======= Collection review update AP added start 16-01-2023 =========== */
/* purpose: for collection review A/B testing  */

function review_elements_function(element){
  createCookie("review_enable",element);  
  setTimeout(function(){    
    if(readCookie('review_enable') == "1"){
      $(".template-collection .collection-listing .product-info .product-block__rating").removeClass("hidden");
      $(".template-index .product-info .product-block__rating").removeClass("hidden");
    }
    else{
      createCookie("review_enable","0");
      $(".template-collection .collection-listing .product-info .product-block__rating").addClass("hidden");
      $(".template-index .product-info .product-block__rating").addClass("hidden");
    }
  },1000);
}
review_elements_function();  
/*======= Collection review update AP added end 16-01-2023 =========== */

/*======= Slide cart subtotal txt update AP added start 24-01-2024 =========== */
function cart_subtotal_txt_function(){   
      setTimeout(function(){
        if(readCookie('subtotal_size') == "true"){
            $('.checkout_block .subtotal_amount, h2.subtotal').addClass("cart_subtotal_txt");
        }else{
            $('.checkout_block .subtotal_amount, h2.subtotal').removeClass("cart_subtotal_txt");
        }       
     },800);
}
cart_subtotal_txt_function();  
/*======= Slide cart subtotal txt update AP added end 24-01-2024 =========== */

/*============ start flash tab msg code ================*/       
var attentionMessage = 'come back!';  
//var attentionMessageCart = "you left item(s) in cart! 🛒";
function createCookies(name, value, days = 90) {
  //   if (days) {
  //   var date = new Date();
  //   date.setTime(date.getTime() + (60 * 24 * 3600 * 1000));
  //   var expires = "; expires=" + date.toGMTString();
  // } else var expires = '';
  // document.cookie = name + "=" + value + expires + "; path=/";

    let cookie = name + "=" + encodeURIComponent(value);

    if (typeof days === "number") {
        /* Sets the max-age attribute so that the cookie expires
        after the specified number of days */
        cookie += ";max-age=" + (days * 24 * 60 * 60) + ';path=/';

                
        document.cookie = cookie;
        cookie_set = true
    }
}
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function deleteCookie(name) {
  document.cookie = name + '=; Path=/collections; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/cart; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/products; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  document.cookie = name + '=; Path=/test; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}  
var pageTitle = document.title;
createCookies("site_title", pageTitle);
createCookies("clear_flag", 0);
createCookies("cart_msg", attentionMessage);
createCookies("beforload_flag", 0);
            
var reset_INT = null;
var three_INT = null;
var first_TO = null;
var init_main_INT = null;
var jqxhr = null;
var index_flash = 0;
var flash_msg = [pageTitle,attentionMessage];       
function getFlashMsg(){
  var m = "";
  if(index_flash == 0){
    m = pageTitle;
  }else{
    m = decodeURIComponent(readCookie("cart_msg"));
  }
  index_flash++;
  index_flash = index_flash>1?0:index_flash;
  return m;
}
createCookies("cart_count", 0);
      
function getCartInTotalItem(cart = ""){
    $.getJSON('/cart.js', function (cart) {
      var cart_result = cart.item_count;
      var protection_product = cart.items.filter(function(item0) {return item0.handle == "green-package-protection"});
      if(protection_product.length > 0){
        cart_result = cart_result - protection_product.length;
      }
      createCookies("cart_count", cart_result);
      if (cart_result >= 1) {
        var attentionMessageCart = "you left " + cart_result + " item(s) in cart! 🛒";
        createCookies("cart_msg", attentionMessageCart);
      }else{
        
        createCookies("cart_msg", attentionMessage);
      }
    });
}
$(window).on('beforeunload', function () {
  createCookies("beforload_flag", 1);
});
document.addEventListener('visibilitychange', function (e) {
  clearInterval(init_main_INT);
  init_main_INT = null;
  clearInterval(reset_INT);
  reset_INT = null;
  clearInterval(three_INT);
  three_INT = null;
  clearTimeout(first_TO); // new
  first_TO = null; // new

  if (document.hidden && readCookie("beforload_flag") != 1) {
    deleteCookie("site_title");
    createCookies("site_title", 1);
    createCookies("clear_flag", 0);
    init_main();
    
    /* GA Event for flash tab */
    if(readCookie("cart_count") > 0){
      if(typeof ga != "undefined" && !$(this).hasClass('active')) 
        ga('send', 'event','Tab Campaign Impression','Tab Campaign Items in Cart','Click desktop flashing tab');
    }else{    	
      if(typeof ga != "undefined" && !$(this).hasClass('active')) 
        ga('send', 'event','Tab Campaign Impression','Tab Campaign No Items in Cart','Click desktop flashing tab');
    }

    
  } else {
    reset_INT = setTimeout(function () { // New
      deleteCookie("site_title");
      createCookies("site_title", pageTitle);
      createCookies("clear_flag", 1);
      document.title = pageTitle;
    }, 500);
  }
}); 
function setPageTitle(flag) { // setTitlePage
  if (readCookie("site_title") != 1) {
    document.title = pageTitle;
  } else {
    document.title = getFlashMsg();
    if (flag) {
      three_second();
    }
  }
}
function three_second() {
  clearInterval(three_INT);
  three_INT = setInterval(function () {
    
    if (readCookie("site_title") == 1) {
      setPageTitle();
    } else {
      deleteCookie("site_title");
      createCookies("site_title", pageTitle);
      document.title = pageTitle;
    }
  }, 2000); // 3000
}
function firstTime() { 
// firstTimeTitle
  if (readCookie("site_title") == 1) { // && parseInt(readCookie('interval')) > 3000
    first_TO = setTimeout(function () {
      
      if (readCookie("site_title") == 1) {
        setPageTitle(1);
        
      } else {
        clearInterval(three_INT); // new
        three_INT = null; // new
        clearTimeout(first_TO); // new
        first_TO = null; // new
    
        document.title = pageTitle; // for quick title
      }
    }, 28000);
  } else {
    clearInterval(three_INT); // new
    three_INT = null; // new
    clearTimeout(first_TO); // new
    first_TO = null; // new
  }
}
function init_main() {
  init_main_INT = setInterval(function () {
    if (readCookie("clear_flag") == 1) {
      clearInterval(three_INT);
      three_INT = null;
      clearTimeout(first_TO); // new
      first_TO = null; // new
    }

    if (readCookie("site_title") == 1) {
      if (first_TO == null) { // TEMP
        firstTime();
      }
    } else {
      clearInterval(three_INT); // new
      three_INT = null; // new
      clearTimeout(first_TO); // new
      first_TO = null; // new

      document.title = pageTitle; // for quick title
    }
  }, 100);
}
getCartInTotalItem();
init_main(); // one time init          
/*======= end flash tab msg code =========== */


var productHandle = "";
var fbSpecialPrice = "";
var blowoutPrice = "";
var mobileSizeDropdown = '';
if(readCookie('campaign-collection') != null)
{
  var campaignArr = [];
  var allCampaign = readCookie('campaign-collection');
  var campaignArr = allCampaign.split(',');
  var utmcampaign = "";
  if($.inArray(utmcampaign,campaignArr) >= 0){
    fbSpecialPrice = 1;
  }
}
/* For about us page Ap added 31-01-2023 */
$(".crafting_process").fancybox(); 

if($("body").hasClass( "template-product" )){
  function refreshStickyBtn(){
    is_sticky_show = true;
    $('.notify_btn').html(" ");
    $('.notify_btn').html($('.notifyme-trigger:not(.custom_quick)').clone());
    var text = $('.product-form .add_to_cart:not(.custom_quick_add)').text();
    var disb_btn = false;
    if(text == "Unavailable" || text == "unavailable"){ disb_btn =true;}
    $('.add_to_cart-small').prop("disabled",disb_btn);
    if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').is(':visible')){
      $('.add_to_cart-small').text(text).removeClass('hidden'); 
    }else{
       $('.add_to_cart-small').text(text).addClass('hidden'); 
    }
    
  }
}
var template = '';

selectCallback = function(variant, selector,$productDetail = "") {
     //  console.log(variant, selector);
  /* AP script added for amzn tracking start 07-12-2023 */
  if(variant != false && variant != undefined){
      var index_i = 0;
      $(selector.options).each(function(index, value) {
        if(value == 'Size'){
          index_i = index_i+1;
        }
      });
    //console.log(variant, " <index_i");
      if(index_i > 0){
        amzn_product_size = variant.options[index_i];
      }
      
  }
  /* AP script added for amzn tracking end 07-12-2023 */
  
       var msg_final_sale = ''; 
       if(selector.tags.indexOf('final sale') > -1 && selector.tags.indexOf('RTS') > -1){
          msg_final_sale = ' This item is final sale. No returns or exchanges.';
       }
      
      
      
      var hours = updatedTime();
      if(parseInt(hours) < 12 && weekdate != 'sun' && weekdate != 'sat'){
        var msg = '<span style="color:black">  Ships Today - Order by 12PM PST '+msg_final_sale+'</span>'; 
      }else{
        var msg = '<span style="color:black">Ships next business day* '+msg_final_sale+'</span>';
      }
  
  
       //console.log("msg",msg);
       $productDetail.find('.notify_btn_submit').prop('disabled', false);
       $productDetail.find('#notify_form_proudct .success_msg').text(" ");
       $productDetail.find('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
       $productDetail.find('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address");
    
          /* added by HB 13-sep-2022 for check model alt length */
          if($productDetail.find('.thumbnail.selected img').length > 0){
            var  model_alt = $productDetail.find('.thumbnail.selected img').attr('alt');
            if(model_alt!=""){            
              model_deail_array = model_alt.split("--");
              if(model_deail_array.length > 1){
                var m_name =  model_alt.split("--")[1];
                /* hd added single or two charecter model name 31/01/23 */
                  m_name = m_name.trim(); 
                  model_name_size = m_name.length;
                  numberCharterNeed =  3 - model_name_size;
                  if(numberCharterNeed > 0){
                    if(numberCharterNeed == 1){
                      m_name = m_name+"‎ ";
                    }else if(numberCharterNeed == 2){
                      m_name = m_name+"‎ "+"‎ ";
                    }
                  }
                 /* hd added single or two charecter model name 31/01/23 */
                
                if(m_name!=""){
                  $productDetail.find(".model_item").addClass('hidden');
                }
                $productDetail.find('.model_item[data-modeinfo="'+m_name.replace(/(["'])/g, "\\$1")+'"]').removeClass('hidden');
              }            
            }            
          }
          
        
        /* hd 25/08/22 added for model info */
  		var $product = $productDetail.find('.product-' + selector.id);
        
        var $notify_form = $productDetail.find('.notify-form-' + selector.id);
        var $productForm = $productDetail.find('form.product_form', $product);
        
        var totalSwatch = 0;
        var count = 0;	
  
        
      	$productDetail.find(".swatch_options .swatch" ).each(function( index ) {
            totalSwatch++;
        });  
        $productDetail.find(".swatch_options .swatch input" ).each(function( index ) {
          if($( this ).is(":checked")){ count++;}
        });

  		if (variant) {   
          $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').removeClass('no-variant');
          
          var actualprice = variant.price / 100;
            /*if ( country_code1 == 'US' || country_code1 == 'CA'){
              productShippingNote(shipRate,actualprice);
            }*/
          	
          
            if (variant.inventory_management == null) {
              
                //  console.log("test3============");                                                                                              
                $productDetail.find('.product_stock', $product).html('');
                $productDetail.find('#made-to-order').val('This is a made-to-order item.');
              if(count > 0 )  $('.agree_pod_true', $product).css('display', 'block');
                $productDetail.find('.agree_pod_true', $product).addClass('agree_pod');
                if(count > 0 ) $productDetail.find('.agree_pod_' + selector.id).css('display', 'block');
                $productDetail.find('.agree_pod_' + selector.id).addClass('agree_pod');
                $productDetail.find('.product_stock_not_pod').html('<span class="instock_label">'+msg+'</span>');
              
                $productDetail.find('.product_stock_' + selector.id).html('');
                $productDetail.find('.product_stock_not_pod_' + selector.id).html('<span class="instock_label">'+msg+'</span>');
              
            } else if (variant.inventory_management == "shopify" && variant.inventory_policy != "continue") {                   
             
                                             
                  if(totalSwatch == count)
                  {
                    /* as per discuse with mam -1 case comment 24/07/2023
                        if varint qty <= 0 and bis tag not found = 'notify me '
                        if varint qty <= 0 and bis tag found = 'sold out '
                        so -1 case now after cofirmation with mam.
                      */
                       
                    //  if (variant.inventory_quantity <= -1) {

                       
                    //  //  console.log("test8============");
                      
                    //     $productDetail.find('.amazonButton', $product).css('display', 'block');
                    //     /*$productDetail.find('.add_to_cart', $product).addClass('sold_out_product');
                    //     $('.add_to_cart-small.sticky-atc').addClass('sold_out_product');*/

                    //     $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').addClass('sold_out_product');/*hd add 28-11-22*/
                    //     $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').addClass('sold_out_product');
                
                    //     $productDetail.find('.product_stock', $product).html('');
                    //     $productDetail.find('.product_stock_not_pod').html('');
                    //     $productDetail.find('.product_stock_' + selector.id).html('');
                    //     $productDetail.find('.product_stock_not_pod_' + selector.id).html('');
                    //     $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                    //     $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                
                    //    if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                    //     // console.log("case1");
                    //       //$('.klaviyo-bis-trigger').addClass('hidden');
                    //       $productDetail.find('.notify_form_bis').addClass('hidden');
                    //       $productDetail.find('.notifyme-trigger').addClass('hidden');
                    //       $productDetail.find('.quantity-submit-row__submit').removeClass('hidden');                        
                    //     }
                       
                    //     $productDetail.find('.price-container').removeClass('hidden');

                    // } else
                    
                    if (variant.inventory_quantity <= 0) {
                     //  console.log("test9============");
                      
                        $productDetail.find('.amazonButton', $product).css('display', 'block');
                        //$productDetail.find('.add_to_cart', $product).addClass('sold_out_product');
                        //$('.add_to_cart-small.sticky-atc').addClass('sold_out_product');

                        $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').addClass('sold_out_product');
                        $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').addClass('sold_out_product');
                
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                        $productDetail.find('.product_stock', $product).html('');
                        $productDetail.find('.product_stock_not_pod').html(' ');
                        $productDetail.find('.product_stock_' + selector.id).html('');
                        $productDetail.find('.product_stock_not_pod_' + selector.id).html(' ');
                      
                      
                      if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                        //console.log("case2");
                        ///$('.klaviyo-bis-trigger').addClass('hidden');
                         
                        $productDetail.find('.notify_form_bis:not(.custom_quick)').addClass('hidden');
                        $productDetail.find('.notifyme-trigger:not(.custom_quick)').addClass('hidden');
                        //$productDetail.find('.quantity-submit-row__submit').removeClass('hidden');
                        $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');
                      }
                      else{

                        //$('.klaviyo-bis-trigger').removeClass('hidden');
                        $productDetail.find('.notify_form_bis:not(.custom_quick)').removeClass('hidden');
                        $productDetail.find('.notifyme-trigger:not(.custom_quick)').removeClass('hidden');
                        $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').addClass('hidden');
                        //$productDetail.find('.quantity-submit-row__submit').addClass('hidden');
                        

                        $productDetail.find(".klaviyo-bis-trigger").click(function(e) {
                          setTimeout(function(){
                            //console.log(backinstock_feature_img);
                            $productDetail.find("#klaviyo-bis-iframe").contents().find('body').find("img").attr('src', '');
                            $productDetail.find("#klaviyo-bis-iframe").contents().find('body').find("img").attr('src', variant.featured_image.src);

                            if(window.matchMedia('(max-width: 375px)').matches){  
                              $productDetail.find("#klaviyo-bis-iframe").contents().find('body').css('overflow','scroll');
                            }
                          },300);
                        });
                      }
                      
                    } else if (variant.inventory_quantity <= 15  || selector.tags.indexOf('low in stock') > -1) {
                      //console.log("test10============");
                      
                      	$productDetail.find('.amazonButton', $product).css('display', 'none');
                        /*$productDetail.find('.add_to_cart', $product).removeClass('sold_out_product');
                        $('.add_to_cart-small.sticky-atc').removeClass('sold_out_product');*/

                       $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').removeClass('sold_out_product');
                       $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').removeClass('sold_out_product');
                       
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');                    
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                        $productDetail.find('.product_stock', $product).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.'+msg+'</span>');
                        $productDetail.find('.product_stock_not_pod').html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.'+msg+'</span>');
                        $productDetail.find('.product_stock_' + selector.id).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.'+msg+'</span>');
                        $productDetail.find('.product_stock_not_pod_' + selector.id).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.'+msg+'</span>');

                        if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                          //console.log("case4");
                          //$('.klaviyo-bis-trigger').addClass('hidden');
                          $productDetail.find('.notify_form_bis').addClass('hidden');
                          $productDetail.find('.notifyme-trigger').addClass('hidden');
                          $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');                        
                        }
                         
                        $productDetail.find('.price-container').removeClass('hidden');
                        //$('.notify_txt').addClass('hidden');
                      
						} else {
                        //console.log("test11============");
                      	
                                                                      
                        $productDetail.find('.amazonButton', $product).css('display', 'none');
                        /*$productDetail.find('.add_to_cart', $product).removeClass('sold_out_product');
                        $('.add_to_cart-small.sticky-atc').removeClass('sold_out_product');*/
                       
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                      	$productDetail.find('.product_stock', $product).html('<span class="instock_label">'+msg+'</span>');
                        $productDetail.find('.product_stock_not_pod').html('<span class="instock_label">'+msg+'</span>');
                        $productDetail.find('.product_stock_' + selector.id).html('<span class="instock_label">'+msg+'</span>');
                        
                       /*if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                          //console.log("case6");
                          //$('.klaviyo-bis-trigger').addClass('hidden');
                          $productDetail.find('.notify_form_bis').addClass('hidden');
                          $productDetail.find('.notifyme-trigger').addClass('hidden');
                          $productDetail.find('.quantity-submit-row__submit').removeClass('hidden');                        
                        }*/
                        $productDetail.find('.price-container').removeClass('hidden');                        
                    }
                }
          }
        
          $productDetail.find('#quantity').attr('data-price-now',variant.price);
        } else {
                      
            //$('.product_stock', $product).html('');
            $productDetail.find('.product_stock_not_pod').html('');
            /*$('.product_stock_' + selector.id).html('');
            $('.product_stock_not_pod_' + selector.id).html('');*/
            //$productDetail.find('.add_to_cart', $product).text($productDetail.find('.add_to_cart', $product).data('add-to-cart-text'));
         
        }   
        
         if (variant == false) {
           //$('.klaviyo-bis-trigger').addClass('hidden');           
           $productDetail.find('.notify_form_bis').addClass('hidden');
           $productDetail.find('.notifyme-trigger').addClass('hidden');
           $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');           
          $productDetail.find('form[data-product-id='+selector.id+']').find('.quick_txt').addClass('soldout_variant'); //AP Added 4-4-2023
         }
                  
        if (variant && variant.available == true) {
          //$('.klaviyo-bis-trigger').addClass('hidden');
          $productDetail.find('.notify_form_bis').addClass('hidden');
          $productDetail.find('.notifyme-trigger').addClass('hidden');
          $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');
          $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').removeClass('sold_out_product');
          $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').removeClass('sold_out_product');

          $productDetail.find('form[data-product-id='+selector.id+']').find('.quick_txt').removeClass('soldout_variant'); //AP Added 4-4-2023
          
           if($productDetail.find('.preorder-inventory-msg').attr('data-'+variant.id)) $productDetail.find('.preorder-inventory-msg').show().text('('+$('.preorder-inventory-msg').attr('data-'+variant.id)+'  Pre-Order Left)');
           else $productDetail.find('.preorder-inventory-msg').hide();
        }
        if($("body").hasClass("product")){ refreshStickyBtn();}
      };


$(document).ready(function(){
  var checkLocalization = readCookie('localization');

  /* partner program hidden content start d.dabhi 15-10-2024 */
  if($.inArray(checkLocalization, ['US']) == 0 || $.inArray(checkLocalization, ['us']) == 0){
    if($("body").hasClass("page")){
      $("body").find(".us-content-only").removeClass("hidden");  
    }    
  }
  else{
    $("body").find(".us-content-only").addClass("hidden");    
  }
  /* partner program hidden content end d.dabhi 15-10-2024 */
  
  if($.inArray(checkLocalization, ['US','CA']) == -1){
    $(".sms_signup-form").remove();
  }

  if($.inArray(checkLocalization, ['US']) != -1){
      $('.sms_signup-form .checkbox_container .us-disclaimer').removeClass('hidden');    
  }else if($.inArray(checkLocalization, ['CA']) != -1){
      $('.sms_signup-form .checkbox_container .ca-disclaimer').removeClass('hidden');    
  }
/* sms phone number save, Add By : HB 9-Aug-2022 */ 
  $('#sms_contact_number').focus(function(){
     $('.sms_signup-form .checkbox_container').removeClass('hidden');    
  });
  
$('#sms_contact_number').click(function(){
   $('#sms_contact_number').removeClass('error_note');
    $('.phone_signup__button').removeClass('error_note');
  var sms_btn_txt = 'TXT Me<span class="btn-right-arrow"><svg width="8" height="9" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Arrow</title><path d="m2 1 4 3.5L2 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  $('.phone_signup__button').html(sms_btn_txt);
  
    $('#sms_contact_number').attr("placeholder", "Phone Number");
});

$(document).on("keypress paste","#sms_contact_number",function() {
     var smsPhoneNumber = $('#sms_contact_number').val();
    if(smsPhoneNumber.length < 4){
      $('#sms_contact_number').val("+1 ");
      $('.sms_signup-form').find('.checkbox_container').removeClass('hidden');
    }
});

/* footer sms form script start */
  function suppressNonNumericInput(event){
        if( !(event.keyCode == 8                                // backspace
            || event.keyCode == 46                              // delete
            || (event.keyCode >= 35 && event.keyCode <= 40)     // arrow keys/home/end
            || (event.keyCode >= 48 && event.keyCode <= 57)     // numbers on keyboard
            || (event.keyCode >= 96 && event.keyCode <= 105))   // number on keypad
            ) {
                event.preventDefault();     // Prevent character input          
        }
    }
$('#sms_contact_number').keyup(function(){
  var smsPhoneNumber = $('#sms_contact_number').val();  
  $(this).val($(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/,'($1) $2-$3'));  
});
  
$(".phone_signup__button").click(function(){
  //  $('.sms_signup-form').find('.checkbox_container').removeClass('hidden');
    var isTermsConditions = $('.sms_signup-form').find('input[name="sms_terms_conditions"]').is(':checked');
    if(isTermsConditions == false){
      //document.getElementById("sms_contact_number_error_msg").innerHTML = "Please select terms conditions";
      $("#sms_contact_number_error_msg").removeClass("hidden");
      $('.sms_signup-form .checkbox_container').removeClass('hidden');
    //  console.log(isTermsConditions + " <<");
      return false;
    }else{
       //document.getElementById("sms_contact_number_error_msg").innerHTML = ""; 
      $("#sms_contact_number_error_msg").addClass("hidden");
     // console.log(isTermsConditions + " <<");
    }
  
    var smsPhoneNumber = $('#sms_contact_number').val();
    if(smsPhoneNumber != "" ) { 
      regexp =  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
      if (!regexp.test(smsPhoneNumber)){
         $('#sms_contact_number').val('');
         $('#sms_contact_number').addClass('error_note');
         $('.phone_signup__button').addClass('error_note');
          //$('.phone_signup__button').html('Text U Later!');
         $('#sms_contact_number').attr("placeholder", "Please enter a valid phone number.");
         return false;
      }  
    }else {      
       $('#sms_contact_number').val('');
       $('#sms_contact_number').addClass('error_note');
       $('.phone_signup__button').addClass('error_note');
       //$('.phone_signup__button').html('Text U Later!');
       $('#sms_contact_number').attr("placeholder", "Please enter mobile."); 
       return false;
    }        
    //document.getElementById("sms_contact_number_success_msg").innerHTML = "";
    $("#sms_contact_number_success_msg").addClass("hidden");
    var checkLocalization = readCookie('localization');
    
    $.ajax({
      type: 'POST',
      dataType: "json",
      data : {"smsPhoneNumber":smsPhoneNumber,"checkLocalization":checkLocalization},
      url: 'https://payments.intotheam.com/private-shopify-app/ajax-allow-origin.php?action=smsiTAMSignupSubscribers&shopDomain=into-the-am.myshopify.com',        
      success: function(response){ 
        if(response.error == 0){
          $('.sms_signup-form').find('input[name="sms_terms_conditions"]').prop("checked", false);
          $('.sms_signup-form').find('.checkbox_container').addClass('hidden');
          $('#sms_contact_number').val('');
          $("#sms_contact_number_success_msg").removeClass("hidden");
          
          if(typeof gtag != "undefined"){
            gtag('event', 'Footer Tracking', {'event_category': 'footer','event_label': 'form field submission','value': 'sms sign-up click'});
          }
          //AP added 24-11-2023
          amzn("trackEvent", "Signup", { page: "Signup" });
          
          setInterval(function() {
            $("#sms_contact_number_success_msg").addClass("hidden");
          }, 5000);
          return true;
        }else{
           $('#sms_contact_number').val('');
           $('#sms_contact_number').addClass('error_note');
           $('.phone_signup__button').addClass('error_note'); 
           //$('.phone_signup__button').html('Text U Later!');           
           $('#sms_contact_number').attr("placeholder", "Please enter a valid phone number."); 
           return false;
        }
      },
      error: function(exception){   
        return false;
      }
    });
  
});

/* footer sms form script end */

/* footer email form script start */
$('.signup-form__email').focus(function(){
     $('.email_signup-form .checkbox_container').removeClass('hidden');    
  });
  
$('.signup-form__email').click(function(){
    $('.signup-form__email').removeClass('error_note');
    $('.email_signup__button').removeClass('error_note');
    $('.signup-form__email').attr("placeholder", "Email Address");
});

  $(document).on('click', '#notify_form_proudct input[name="notify_accepts_marketing"]', function(){
    var $contain = $(this);
    var notify_form_proudct = $contain.closest("#notify_form_proudct");
  
    var isTermsConditionsEmail = notify_form_proudct.find('input[name="notify_accepts_marketing"]').is(':checked');
  
    if(isTermsConditionsEmail == false){
      notify_form_proudct.find("#notify_form_proudct_error_msg").removeClass("hidden");
      notify_form_proudct.find('input[name="notify_accepts_marketing"]').prop('checked', false);
      notify_form_proudct.find('.notify_btn_submit').addClass('no-variant');     
    }else{
      notify_form_proudct.find("#notify_form_proudct_error_msg").addClass("hidden");
      notify_form_proudct.find('input[name="notify_accepts_marketing"]').prop('checked', true);
      notify_form_proudct.find('.notify_btn_submit').removeClass('no-variant');
    } 
});

function backInStockSubscriptions(email,selectedVariantId){
    const options2 = {
    method: 'POST',
    headers: {
        accept: 'application/json',
        revision: '2023-08-15',
        'content-type': 'application/json',
    },
    body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email},
              },
            },
            },
            relationships: {
             variant: {
               data: {
                type: 'catalog-variant',
                id:"$shopify:::$default:::"+selectedVariantId,
                },
              },
            },
          },
      }),
    }
    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=PjKgix`, options2)
    .then((response) => {
    //console.log('response==2',response)
    })
    .catch((error) => console.error(error))
}  
//$('.notify_btn_submit').click(function(){
$(document).on('click', '.notify_btn_submit', function(){
    var $contain = $(this);
    var notify_form_proudct = $contain.closest("#notify_form_proudct");
     var isTermsConditionsEmail = notify_form_proudct.find('input[name="notify_accepts_marketing"]').is(':checked');
      if(isTermsConditionsEmail == false){
        notify_form_proudct.find('#notify_form_proudct_error_msg').removeClass("hidden");
        $contain.addClass('no-variant');
        return false;
      }else{
        $contain.removeClass('no-variant');
        notify_form_proudct.find("#notify_form_proudct_error_msg").addClass("hidden");
      } 
      var contact_email = notify_form_proudct.find('input[name="contact[email]"]').val();
    
      if(contact_email == "" ) { 
       notify_form_proudct.find('input[name="contact[email]"]').val('');
       notify_form_proudct.find('input[name="contact[email]"]').addClass('error_note');
       notify_form_proudct.find('input[name="contact[email]"]').addClass('error_note');
       notify_form_proudct.find('input[name="contact[email]"]').attr("placeholder", "Please enter a valid email address."); 
       $contain.addClass('no-variant');     
        return false;    
      }
      $contain.removeClass('no-variant');     
      //var variant_id = $contain.find('.product-purchase-form .original-selector').val(); 
      var variant_id = $contain.closest('.buy-buttons-row').find('.product-purchase-form .original-selector').val()
      var product_id = $contain.closest('.buy-buttons-row').find('.product-purchase-form').data('product-id');  
                       //$contain.find('.product-purchase-form').data('product-id');
      //console.log('variant_id',variant_id)
      //console.log('product_id',product_id)
      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2023-08-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: contact_email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'NqCekM'
                }
              }
            },
          },
        }),
      }
     fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=PjKgix`, options)
        .then((response) => {
          //console.log('response.status',response);
          if(response.ok && response.status == 202){
              notify_form_proudct.find('.success_msg').text("You're in! We'll let you know when it's back");
              $contain.prop('disabled', true);
              amzn("trackEvent", "Subscribe"); 

              notify_form_proudct.find('input[name="contact[email]"]').val(" ");
              notify_form_proudct.find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
              notify_form_proudct.find('input[name="notify_accepts_marketing"]').prop('checked', false);
              backInStockSubscriptions(contact_email,variant_id);
          }else{
               $contain.prop('disabled', false);
               notify_form_proudct.find('input[name="contact[email]"]').val(" ");
               notify_form_proudct.find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
              return false;   
          }
        }).catch((error) =>{
           $contain.prop('disabled', false);
           notify_form_proudct.find('input[name="contact[email]"]').val(" ");
           notify_form_proudct.find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
          return false;   
        });
  });

/*$('#notify_form_proudct input[name="notify_accepts_marketing"]').click(function(){
    var isTermsConditionsEmail = $('#notify_form_proudct').find('input[name="notify_accepts_marketing"]').is(':checked');
    if(isTermsConditionsEmail == false){
      $("#notify_form_proudct_error_msg").removeClass("hidden");
      $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
      $('.notify_btn_submit').addClass('no-variant');     
    }else{
      $("#notify_form_proudct_error_msg").addClass("hidden");
      $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', true);
      $('.notify_btn_submit').removeClass('no-variant');
    } 
});
$('.notify_btn_submit').click(function(){
     var isTermsConditionsEmail = $('#notify_form_proudct').find('input[name="notify_accepts_marketing"]').is(':checked');
      if(isTermsConditionsEmail == false){
        $("#notify_form_proudct_error_msg").removeClass("hidden");
        $('.notify_btn_submit').addClass('no-variant');
        return false;
      }else{
        $('.notify_btn_submit').removeClass('no-variant');
        $("#notify_form_proudct_error_msg").addClass("hidden");
      } 
      var contact_email = $('#notify_form_proudct').find('input[name="contact[email]"]').val();
    
      if(contact_email == "" ) { 
       $('#notify_form_proudct').find('input[name="contact[email]"]').val('');
       $('#notify_form_proudct').find('input[name="contact[email]"]').addClass('error_note');
       $('#notify_form_proudct').find('input[name="contact[email]"]').addClass('error_note');
       $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Please enter a valid email address."); 
       $('.notify_btn_submit').addClass('no-variant');     
        return false;    
      }
      $('.notify_btn_submit').removeClass('no-variant');     
      var variant_id = $('.product-purchase-form .original-selector').val(); 
      var product_id = $('.product-purchase-form').data('product-id');
  
       $.ajax({
        type: "POST",
        url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
        data: {
          a:"PjKgix",
          email:contact_email,
          g:"NqCekM",
          variant:variant_id,
          product:product_id,
          platform:"shopify",
          subscribe_for_newsletter:"true"
        },
        success: function(response) {
        //  console.log("success==>",response);
          if(response.success){
            $('#notify_form_proudct .success_msg').text("You're in! We'll let you know when it's back");
            $('.notify_btn_submit').prop('disabled', true);
            amzn("trackEvent", "Subscribe"); 
          }
          $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
          $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
          $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
        },
        error: function(response){   
          //console.log("success==>",response);
           $('.notify_btn_submit').prop('disabled', false);
           $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
           $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
          return false;   
        }
      });
    
  });
  */
$(".email_signup__button").click(function(){
    //var isTermsConditions = $('.signup-form__email').find('input[name="email_terms_conditions"]').is(':checked'); 
    var isTermsConditionsEmail = $('.email_signup-form').find('input[name="email_terms_conditions"]').is(':checked'); 
    if(isTermsConditionsEmail == false){
      $("#newsletter_error_msg").removeClass("hidden");
      $('.email_signup-form .checkbox_container').removeClass('hidden');
      return false;
    }else{
       //document.getElementById("sms_contact_number_error_msg").innerHTML = ""; 
      $("#newsletter_error_msg").addClass("hidden");
    } 

    var signupEmailVal = $('.signup-form__email').val();
    if(signupEmailVal == "") { 
      $('.signup-form__email').val('');
       $('.signup-form__email').addClass('error_note');
       $('.email_signup__button').addClass('error_note');
       $('.signup-form__email').attr("placeholder", "Please enter email."); 
       return false;    
    }
    if(!ValidateEmail(signupEmailVal) ) { 
      $('.signup-form__email').val('');
       $('.signup-form__email').addClass('error_note');
       $('.email_signup__button').addClass('error_note');
       $('.signup-form__email').attr("placeholder", "Please enter a valid email address."); 
       return false;    
    }
    //$( "form#footer_newsletter_signup" ).submit();
    var dataString =$('form#footer_newsletter_signup').serialize();
    $.ajax({
      type: "POST",
      url: 'https://www.intotheam.com/contact',
      data: dataString,
      success: function(response) {
          $('.email_signup-form').find('input[name="email_terms_conditions"]').prop("checked", false);
          $('.email_signup-form').find('.checkbox_container').addClass('hidden');
          $('.signup-form__email').val('');
          $("#newsletter_success_msg").removeClass("hidden");
         if(typeof gtag != "undefined"){
            gtag('event', 'Footer Tracking', {'event_category': 'footer','event_label': 'form field submission','value': 'email sign-up click'});
          }
        
          amzn("trackEvent", "Contact"); 
        
          setInterval(function() {
            $("#newsletter_success_msg").addClass("hidden");
          }, 5000);
          return true;
      },
       error: function(response){   
          return false;
        }
    });
    
  });
/* footer email form script end */
});
/* Product detail page review click event start */
$(".header_section").click(function(e) {	
     if(!$('.cc-accordion-item__title.reviews').parent().hasClass("is-open")) {
     	$('.cc-accordion-item__title.reviews').parent().addClass("is-open").attr('open', 'true');
      }
});
/* Product detail page review click event end */
$(".description").closest(".product-detail-accordion").css({"border": "none"});
$('.scroll_top_container').click(function(){  $("html, body").animate({ scrollTop: 0 }, 600); return false; }); 

if($(window).width() <= 767) {
$("body").find('h5.section-footer__title').addClass("cc_accordion"); 
$("body").find('.section-footer__menu-block__menu').addClass("panel");
  var wind_width ="";
  
  if($("body").hasClass("template-cart")) {
    wind_width =  $(window).width() - 30;   
  }else{
    wind_width =  $(window).width() - 25;
  }
  $(".swatch_scroller").css({"max-width": wind_width});
  
}
var acc = document.getElementsByClassName("cc_accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
  this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
     $(panel).toggle(500);
    } else {      
       $(panel).toggle(500);
    }
  });  
}
  
// $(".swatch.swatch-size").clone().prependTo(".swatch-size-sticky");

/*setTimeout(function(){
 $(".swatch-size-sticky").html($(".swatch.swatch-size").children().clone());
},1000);*/

//$(".swatch-size-sticky").find(".js-option").remove();
 //$(".swatch-size-sticky").find(".opt-btn").removeAttr('id');
  
$(".my_size_chart").click(function(){ 
  if($('body').hasClass('product.subscription')){
    
  }else{
    $('html, body').animate({
          scrollTop: $(".size_fit").offset().top - 100
      }, 1000);  
    if(!$(".size_fit").parent().hasClass('is-open')){
      	$(".size_fit").trigger("click");    
    }
  }
  
});

var intervalStampedInstagram = setInterval(function(){
    if($('.stamped-instagram-media-block').length > 0 && $(".custom-html").find(".app_title").length > 0){
        if($('.stamped-instagram-media-block').length < 2){
          $(".custom-html").find(".app_title").addClass("hidden");      
        }else{
          $(".custom-html").find(".app_title").removeClass("hidden");      
        }
        clearInterval(intervalStampedInstagram);
    }
},3000);

$(".cc-accordion-item").on("click", function () {
  $('.cc-accordion-item').not($(this)).removeClass('is-open').removeAttr('open');
    if ($(this).hasClass("is-open")) {
        $('.cc-accordion-item').not($(this)).removeClass('is-open').removeAttr('open');
    }else{
      setTimeout(function () {
        $(this).addClass("is-open").attr('open');
      }, 100);      
    }
});



jQuery(document).ready(function ($) {

   $('.footer_chat_btn').on('click',function(e){
       $('body').find("#chat-button").show();
   });
  
  $('.collection_description').removeClass('collection_description_before');
  $('.collection_description').readmore({ collapsedHeight: 55,speed: 500,lessLink: '<a href="#" class="morelink">Less <span class="roted_up"> <i class="fa-solid fa-angle-up"></i> </span></a>',moreLink: '<a href="#" class="morelink">Read More <span class="roted_down"> <i class="fa-solid fa-angle-down"></i> </span></a>',
     beforeToggle: function() { if($('.collection_description').attr('aria-expanded') == "true"){ $('.collection_description').removeClass('collectiontoggle');}else{ $('.collection_description').addClass('collectiontoggle'); } } 
  });
  if(!$('.collection_description').attr('aria-expanded')){ $('.collection_description').addClass('collectiontoggle'); } 


  if($("body").hasClass( "product" )){
  
    var hidden = $('.swatch-size-sticky');
    $('.swatch-size-sticky').addClass("hidden");
     $('.sticky_option_selector').click(function(event){ 
      $('.swatch-size-sticky').removeClass("hidden");
      if(window.matchMedia('(min-width: 767.99px)').matches){
        //$('.swatch-size-sticky').animate({"left":"65px","opacity":"1"}, "slow");
        $('.swatch-size-sticky').toggleClass("open-desktop");      
      }else{
          $('.swatch-size-sticky').toggleClass("open");       
      }
    });
    
    jQuery('body').on('click',function(event){
    
    if(!jQuery(event.target).is('.sticky-options .sticky_option_selector, .sticky-options .opt-btn, .sticky-options .option-selector__btns , .sticky-options .opt-label, .sticky-options .opt-label__text, .option-selector-fieldset, .sticky-options .add_to_cart') ) {
      /*if(window.matchMedia('(min-width: 767.99px)').matches){
         $('.swatch-size-sticky').animate({"left":"-1000px"}, "slow");          
      }else{
        $('.swatch-size-sticky').toggleClass("open");          
      }*/
      if(jQuery(event.target).is('.sticky-options .add_to_cart-small')){
          product_title = product_title.replace("&#39;","'");
        if(typeof gtag != "undefined"){
          gtag('event', 'Product Page Tracking', {'event_category': 'product page','event_label': 'add to cart sticky','value': product_title});   
        }

        if(amzn_product_size != ""){
          //console.log("value:"+ amzn_product_price+",currencyCode:"+ amzn_currencyCode+",name:"+ product_title+",size:"+ amzn_product_size);
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title,size: amzn_product_size});  
        }else{
          //console.log("value:"+ amzn_product_price+",currencyCode:"+ amzn_currencyCode+",name:"+ product_title);
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title});  
        }
        
        
        //$(".product-purchase-form .add_to_cart:not(.custom_quick_add)").trigger("click");
        //$('.product-purchase-form').submit();
        $('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').submit();
      }else if(!jQuery(event.target).is('.custom_quick_row__submit .button.button--large.add_to_cart') && jQuery(event.target).is('.sign-up-wrap .sign-up-btn')){
         product_title = product_title.replace("&#39;","'");
        if(typeof gtag != "undefined"){
            gtag('event', 'Product Page Tracking', {'event_category': 'Subscription product page','event_label': 't-club add to cart','value': product_title});   
        }
        if(amzn_product_size != ""){         
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title,size: amzn_product_size});  
        }else{
          //console.log("value:"+ amzn_product_price+",currencyCode:"+ amzn_currencyCode+",name:"+ product_title);
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title});  
        }
        
      }else if(!jQuery(event.target).is('.custom_quick_row__submit .button.button--large.add_to_cart') && jQuery(event.target).is('.product-column-right .button.button--large.add_to_cart')){
         product_title = product_title.replace("&#39;","'");
        if(typeof gtag != "undefined"){
            gtag('event', 'Product Page Tracking', {'event_category': 'product page','event_label': 'add to cart inline','value': product_title});   
        }
        if(amzn_product_size != ""){
         //console.log("value:"+ amzn_product_price+",currencyCode:"+ amzn_currencyCode+",name:"+ product_title+",size:"+ amzn_product_size);
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title,size: amzn_product_size});  
        }else{
          //console.log("value:"+ amzn_product_price+",currencyCode:"+ amzn_currencyCode+",name:"+ product_title);
          amzn('trackEvent', 'AddToCart', {value: amzn_product_price,currencyCode: amzn_currencyCode, unitsSold: 1, name: product_title});  
        }        
      }else if(jQuery(event.target).is('.sticky-options .notifyme-trigger')){
        /*$('.notify_form_bis:not(.custom_quick)').find('input[name="notify_accepts_marketing"]').is(':checked');
          $('.notify_form_bis:not(.custom_quick)').find('input[name="contact[email]"]').val();*/
        $('.notify_form_bis:not(.custom_quick) .notify_btn_submit').trigger("click");
        $(window).scrollTop($('.notify_form_bis:not(.custom_quick)').position().top);
      }
    }else if (jQuery(event.target).is('.opt-label__text')) {
      var seleceted_val = jQuery(event.target).closest('.opt-label').data('value');
      $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
      $('.swatch-size-sticky').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
      
    }else if(jQuery(event.target).is('.opt-label')){
        var seleceted_val = jQuery(event.target).data('value');
        $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
        $('.swatch-size-sticky').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change'); 
    }
    });

if(!$("body").hasClass("product.subscription")) {
    var is_sticky_show = false;
     $(window).scroll(() => {

      var scrollTop     = $(window).scrollTop(),
          elementOffset = $('.mobile_only_mobile_stuff').offset().top,
          distance      = (elementOffset - scrollTop);

      if (distance <= 0){

        if(is_sticky_show==false){
          is_sticky_show = true;
          $('.notify_btn').html(" ");
          $(".sticky-options").removeClass('hidden');
          
          var sticky_size = $('.product-form .swatch:not(.custom_quick):not(.swatch-color):not(.swatch-inseam)').children().clone();
          var name = sticky_size.find('input').attr("name")+"-ticky";
          
          /*hd added giftcart type proudt 28/04/23*/
          //var sticky_lable = $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('.opposing-items .label').text();
           /*var sticky_lable = $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('.opposing-items .label span').text();
              sticky_lable = sticky_lable.replace(":", ""); 
              sticky_lable = sticky_lable +' Selector';*/

          /* hd updated 11/08/2023 */
          var sticky_lable = $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('.opposing-items .label').text();
          if(sticky_lable){
            var sticky_lable_temp = sticky_lable.split(":");
                sticky_lable = sticky_lable_temp[0];   
          }else{
              sticky_lable = ' Selector';
          }
          sticky_lable = sticky_lable.replace(":", ""); 
          sticky_lable = sticky_lable +' Selector';
          $('.sticky_option_selector').html(sticky_lable+'<span class="sticky_option_arrow"><svg width="5" height="7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 1 2.5 2.5L1 6" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>');
          
          sticky_size.find('input').attr("name",name);
          sticky_size.find('label').attr("for","");
          $(".swatch-size-sticky").html(sticky_size);
          $('.notify_btn').html($('.notifyme-trigger:not(.custom_quick)').clone());
          $('.swatch-size-sticky').addClass("size-sticky");
          
          var text = $('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').text();
          var disb_btn = false;
          if(text == "Unavailable" || text == "unavailable"){ disb_btn =true;}
          
          $('.add_to_cart-small').prop("disabled",disb_btn);
          if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').is(':visible')){
            $('.add_to_cart-small').text(text).removeClass('hidden'); 
          }else{
             $('.add_to_cart-small').text(text).addClass('hidden'); 
          }
          if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').hasClass('no-variant')){
            $('.add_to_cart-small').addClass('no-variant'); 
          }else{
            $('.add_to_cart-small').removeClass('no-variant'); 
          }
        }
      } else{
        is_sticky_show = false;
        $(".swatch-size-sticky").children().remove();
        $('.swatch-size-sticky').removeClass("size-sticky");
        $(".sticky-options").addClass('hidden');      
      }      
    });

  }
    
  }
  
});

var announcementBarEnable = setInterval(function(){
  if($("#announcement-bar-with-slider").length > 0){
    var announcement_bar_size = $("#announcement-bar-with-slider").height();
  
    $("body").addClass("announcement-bar-enable");
    $("body").find(".section-header").css({"top":announcement_bar_size});

     $(document).on('click','#announcement-bar-with-slider a',function(){      
       if(typeof gtag != "undefined")		
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar click','value': 'click promo bar'});
    });
    
    //$("body").find(".cart-summary-overlay").css({"top":announcement_bar_size});
    //$("body").addClass("mini_cart_open");
      clearInterval(announcementBarEnable);
  }
 $('.ab-slide-remove').on('click',function(event){
   if(typeof gtag != "undefined"){
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar close','value': 'promo bar closed'});
   }
  $("body").removeClass(".announcement-bar-enable");
  $("body").find(".section-header").css({"top":"0"});
});
}, 1000);

if($("body").hasClass("template-product")) {
    var ll = $('.description.description-full-bottom div'); 	
    var lh = [];
    var wscroll = 0;
    var wh = $(window).height();

    function update_offsets(){
      $('.description.description-full-bottom div').each(function(){
        var x = $(this).offset().top;
        lh.push(x);
      });
    };

    function lazy() {          
      wscroll = $(window).scrollTop();
      for(i = 0; i < lh.length; i++){
        if(lh[i] <= wscroll + (wh - 100)){
          $('.description.description-full-bottom div').eq(i).addClass('loaded');
          if($('.description.description-full-bottom .ignore-float').height() >$('.description.description-full-bottom').height() && $(".description.description-full-bottom").attr('aria-expanded') == 'true' ){
            var height =$('.description.description-full-bottom .ignore-float').height()+50;
            //           $('.description.description-full-bottom').css('height',height+'px');
          }
        };
      };
    };

      // Page Load
    update_offsets();
    lazy();

    $(window).on('scroll',function(){           
      lazy();
    });
  }
/* Script added for header search functionality AP 29/09/2022 */
if(window.matchMedia('(max-width: 767px)').matches){
  $(".header-account-wrapper").removeClass("desktop-only");  
}
$(window).resize(function() {
  if(window.matchMedia('(min-width: 767px)').matches){
    $(".header-account-wrapper").addClass("desktop-only");  
  }else{   
    $(".header-account-wrapper").removeClass("desktop-only");
  }
});

/* Script added for Home page section and collection banner AP 29/09/2022 */
$(document).ready(function(){
  var checkLocalization = readCookie('localization');
  
  if($.inArray(checkLocalization, ['US']) == 0 || $.inArray(checkLocalization, ['us']) == 0){
    if($("body").hasClass("collection")){
      $("body").find(".intl_collection_banner").remove();
      $("body").find(".us_collection_banner").removeClass("hidden");  
    }
      
    $("body").find(".int_content").remove();
    $("body").find(".us_content").removeClass("hidden");
  }
  else{

    if($("body").hasClass("collection")){
      $("body").find(".us_collection_banner").remove();
      $("body").find(".intl_collection_banner").removeClass("hidden");  
    }
    
 //   console.log("intl call");    
    $("body").find(".us_content").remove();    
    $("body").find(".int_content").removeClass("hidden");      
  }
  
});

function lighthouseShow() {
 $('#lighthouse').show(); Lighthouse.showButton();Lighthouse.show(); 
}
// add by HB 22-Mar-2023 for brave browser img load issue solution 
// function isBrave() {
//   if(window.navigator.brave!='' && window.navigator.brave!=undefined && window.navigator.brave.isBrave.name == "isBrave") {
//     return true;
//   } else {
//     return false;
//   }
// }
function ValidateEmail(inputText){
  /*var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if(inputText.match(mailformat)){ return true;}
  else{ return false;}*/
  var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
  return pattern.test(inputText);
}

// scrolling on filter
//AP script updated for announcementbar filter spacing 20-11-2023

function calculateMarginTopForContent(){
  var announcementbar = $('#announcement-bar-with-slider').height();
  var page_header_height = $('.pageheader').height();
  var filter_mobile = $('body');
  var essential_countdown_bar = $(".essential_countdown_annoucement_bar_wrapper").outerHeight();
  var custom_announcementbar = $(".section-announcement-bar").outerHeight();
  var scroll_pageheader = 0;
  
  //console.log(announcementbar + " <<scroll_pageheader11110");
  if($('#announcement-bar-with-slider').length > 0 ){  
      scroll_pageheader = ( announcementbar + page_header_height );  
      //console.log(scroll_pageheader + " <<scroll_pageheader2");  
  }
  else if ($(".essential_countdown_annoucement_bar_wrapper") > 0){    
      scroll_pageheader = ( essential_countdown_bar + page_header_height );
  }
  else{
      scroll_pageheader = page_header_height;
  }
  
  if(scroll_pageheader == 0){
    if(custom_announcementbar == undefined){
      scroll_pageheader = page_header_height;
    }
    else{
       scroll_pageheader = ( custom_announcementbar + page_header_height );  
        // $('body').find('#content').css("top", custom_announcementbar+ 'px');
      // console.log(custom_announcementbar+ " <<custom_announcementbar");
    } 
  }
  
  //$('.mobile-spacing').find('.utility-bar--sticky-mobile-copy').css("top", scroll_pageheader+ 'px');
  $('body').find('.utility-bar--sticky-mobile-copy').css("top", scroll_pageheader+ 'px');
  //console.log(scroll_pageheader + " <<scroll_pageheader added");
}

/* Added this JS collection card RK 17-05-2024 Start */
if($("body").hasClass( "collection.collection-with-card" )){
 
if ($(window).width() > 767) {
  //console.log("if call1"+ $('.card-product-list .collection_card_item').length);

  var card_count = $('.card-product-list .collection_card_item').length;

  if (card_count > 4) {
      $('.card-product-list').removeClass('nonecard-slider');
      $(".card-product-list").slick({
        dots: false,
        infinite: false,
        speed: 500,
        smoothScroll:true,
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 4,
        responsive: [
          {
            breakpoint:1280,
            settings: {
              centerPadding: '80px',
              slidesToShow: 4
            }
          },
          {
            breakpoint: 980,
            settings: {
              centerPadding: '60px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              centerPadding: '20px',
              slidesToShow: 2,
              centerMode: false
            }
          }
        ]
      });
      
    $('body').find('.collection-card').removeClass('hidden ');
    $(".card-product-list").slick('refresh');
    
  }
  else if (card_count <= 3) {
    $('.card-product-list').addClass('nonecard-slider');
    $('.collection-card').removeClass('hidden ');
  }
  else{
    $('.collection-card').removeClass('hidden ');
  }
  
 }
  else{
    $('.collection-card').removeClass('hidden ');
  }
}
/* Added this JS collection card RK 17-05-2024 end */

$(window).scroll(function() {
    if ($(window).width() < 768) {
      calculateMarginTopForContent();
      
      var window_scroll = $(window).scrollTop();
       if (window_scroll > 20) {
         $('body').addClass("utility-bar-sticky-mobile-copy-reveal");
         /* hd added for collection count issue fixed in mobile */
         if($('body').hasClass('collection')){
           if($('.utility-bar--sticky-mobile-copy .utility-bar__centre .utility-bar__item').length > 0){
             $('.utility-bar--sticky-mobile-copy .utility-bar__centre .utility-bar__item').text($('.utility-bar .utility-bar__centre .utility-bar__item')[0].outerText);
           }
            if($('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').length > 0){
              var count_text = $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
              if(count_text == undefined){
                $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').remove();
              }else{
                $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').html(count_text);
              }
            }else{
              var count_text =  $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
              if(count_text!= undefined ){
                $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item').append('<span class="toggle-btn__count">'+count_text+'</span>');
              }
            }
         }
      } else{
         $('body').removeClass("utility-bar-sticky-mobile-copy-reveal");
      }
      calculateMarginTopForContent();
    }
});

$(window).resize(function() {
  if ($(window).width() < 768) {
     calculateMarginTopForContent();
  }
});

if ($(window).width() < 768) {
  setTimeout(function(){
    $('.ab-slide-remove').on( "click", function() { 
        calculateMarginTopForContent();
    });
  }, 1500);
calculateMarginTopForContent();  
}

$(window).on( "load", function() { 
  if ($(window).width() < 768) {
    setTimeout(function(){
      calculateMarginTopForContent();
    }, 1500);     
  }
  
  var chat_iframe = $('#chat-button').contents();  
    chat_iframe.find("#gorgias-chat-messenger-button").click(function(){
       $('body').find("#chat-button").hide();
    });  
  multi_tag_hide_function(); //AP added 05-01-2024
});


// header transparent on mobile d.dabhi 22-07-2024
if(!$('body').hasClass('product.subscription')){
var headerTransparent = setInterval(function(){
  
    //console.log("scroll down",document.body.getBoundingClientRect().top);
    //header transparent class
    var pageHeader = document.getElementById('pageheader');
    if (pageHeader.classList.contains('pageheader--transparent-permitted') && $("#announcement-bar-with-slider").length > 0) {
      
      var section_header_size = $(".section-header").height();
      //console.log(section_header_size,"section_header_size");
        if (window.innerWidth <= 767) {
         pageHeader.classList.remove('pageheader--transparent');
          //console.log("section_header_size",section_header_size);
          $("body").find("#content").css({"top":section_header_size, "margin-bottom":section_header_size});        
        }else{
           if(document.body.getBoundingClientRect().top > -150){
            pageHeader.classList.add('pageheader--transparent');  
          }         
          
          //console.log("added class");        
      }   
    }
  
}, 2000); 
}

